// Both prices come from data attributes rendered by Liquid, so there is no cached
// DOM state to go stale when Horizon re-renders the product section on variant change.
function esaApplyPrice(radio) {
  const widget = radio.closest('subscription-widget');
  if (!widget) return;

  const price = radio.value !== ''
    ? widget.dataset.subscriptionPrice
    : widget.dataset.onetimePrice;

  if (!price) {
    console.warn('[esa] missing price data attribute on <subscription-widget>');
    return;
  }

  // querySelectorAll, not querySelector: themes often render a second copy of the
  // price for mobile / sticky bar, and updating only the first leaves the visible one stale.
  const targets = document.querySelectorAll(
    'product-price .price-item--sale, product-price .price-subscription'
  );
  if (!targets.length) {
    console.warn('[esa] no price element matched inside <product-price>');
    return;
  }
  targets.forEach((el) => { el.textContent = price; });
}

// Delegated on document, so it keeps working after the theme replaces the widget,
// the radios, or the whole section.
document.addEventListener('change', (e) => {
  if (e.target && e.target.name === 'selling_plan') esaApplyPrice(e.target);
});

class SubscriptionWidget extends HTMLElement {
  connectedCallback() {
    this.lastSearch = location.search;
    // Changed 2026-08-28 (issue M-06): this used to poll location.search every
    // 400ms for the whole page lifetime (2.5 wakeups/second on four product
    // templates). Horizon dispatches bubbling 'variant:update' and
    // 'variant:selected' events on document (see assets/events.js ThemeEvents),
    // and history navigation fires popstate, so those now drive the check.
    // The interval is kept only as a safety net for URL changes that emit
    // neither signal, at 2000ms instead of 400ms.
    this.onVariantChange = () => {
      this.checkVariant();
      // The URL is sometimes rewritten just after the event is dispatched, so
      // re-check on the next tick rather than waiting for the safety net.
      clearTimeout(this.recheck);
      this.recheck = setTimeout(() => this.checkVariant(), 50);
    };

    window.addEventListener('popstate', this.onVariantChange);
    document.addEventListener('variant:update', this.onVariantChange);
    document.addEventListener('variant:selected', this.onVariantChange);

    this.poll = setInterval(() => this.checkVariant(), 2000);
  }

  disconnectedCallback() {
    clearInterval(this.poll);
    clearTimeout(this.recheck);
    window.removeEventListener('popstate', this.onVariantChange);
    document.removeEventListener('variant:update', this.onVariantChange);
    document.removeEventListener('variant:selected', this.onVariantChange);
  }

  checkVariant() {
    if (location.search === this.lastSearch) return;
    this.lastSearch = location.search;
    this.refresh();
  }

  refresh() {
    const url = new URL(location.href);
    url.searchParams.set('section_id', this.dataset.sectionId);
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('esa__subscription-widget');
        if (fresh) {
          this.dataset.variantId = fresh.dataset.variantId;
          this.dataset.onetimePrice = fresh.dataset.onetimePrice;
          this.dataset.subscriptionPrice = fresh.dataset.subscriptionPrice;
          this.innerHTML = fresh.innerHTML;
          this.style.display = 'block';
        } else {
          this.innerHTML = '';
          this.style.display = 'none';
        }
      });
  }
}

customElements.define('subscription-widget', SubscriptionWidget);